import React, { createRef } from 'react';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGithub, faInstagram, faFacebook, faLinkedin
} from '@fortawesome/free-brands-svg-icons';
import { faAt, faForward } from '@fortawesome/free-solid-svg-icons';
import showdown from 'showdown'; // Uma biblioteca de markdown de código aberto de terceiros
import Prism from 'prismjs';

import style from 'raw-loader!components/Animation/style1.txt'; // Observe que as sequências de análise usando o carregador bruto
import style2 from 'raw-loader!components/Animation/style2.txt';
import experience from 'raw-loader!components/Animation/experience.md';
import education from 'raw-loader!components/Animation/education.md';
import skills from 'raw-loader!components/Animation/skills.md';

import Layout from 'components/Layout';
import SEO from 'components/SEO';

const refAbout = createRef();
const refExperience = createRef();
const refEducation = createRef();
const refSkills = createRef();

const aboutFunction = ( that, text, char ) =>
{
  const origin = (text) ? text : (that.state.DOMaboutText + char);
  const html = Prism.highlight( origin, Prism.languages.css );
  that.setState( {
    aboutText: html,
    DOMaboutText: origin,
  } );
}

const experienceFunction = ( that, text, char ) =>
{
  const originResume = (text) ? text : (that.state.experienceText + char);
  that.setState( {
    experienceText: originResume,
    DOMexperienceText: markdownReadFunction( originResume ),
  } );
}

const educationFunction = ( that, text, char ) =>
{
  const originResume = (text) ? text :  (that.state.educationText + char);
  that.setState( {
    educationText: originResume,
    DOMeducationText: markdownReadFunction( originResume ),
  } );
}

const skillsFunction = ( that, text, char ) =>
{
  const originResume = (text) ? text : (that.state.skillsText + char);
  that.setState( {
    skillsText: originResume,
    DOMskillsText: markdownReadFunction( originResume ),
  } );
}

const markdownReadFunction = ( originResume ) =>
{ 
  const converter = new showdown.Converter();
  const markdownResume = converter.makeHtml( originResume );
  return markdownResume;
}

const writeFuction = ( that, nodeName, char ) =>
{
  if ( nodeName === 'about' ) {
    aboutFunction(that, '', char)
    refAbout.current.scrollTop = refAbout.current.scrollHeight;
  } else if ( nodeName === 'experience' ) {
    experienceFunction( that, '', char );
    refExperience.current.scrollTop = refExperience.current.scrollHeight;
  } else if ( nodeName === 'education' ) {
    educationFunction( that, '', char );
    refEducation.current.scrollTop = refEducation.current.scrollHeight;
  } else if ( nodeName === 'skills' ) {
    skillsFunction( that, '', char );
    refSkills.current.scrollTop = refSkills.current.scrollHeight;
  }
  else {
    /* É esse controle, quando se encontra símbolos ! ? ,  Estenda o tempo quando é ! ? , */
    if ( char === '?' || char === ', ' || char === '!' ) {
      ( !that.state.forward ) ? that.setState( {interval: 200}) : false;
    } else {
      ( !that.state.forward ) ? that.setState( {interval: 15}) : false;
    }
  }
}

const writeChars = (that, nodeName, char) => new Promise((resolve) => {
  setTimeout(() => {
    writeFuction( that, nodeName, char );
    resolve();// Certifique-se de escrever a função de promessa, caso contrário você não obterá o resultado da promessa
  }, that.state.interval);
});

const writeTo = async (that, nodeName, index, text) => {
/* Lendo uma palavra de cada vez, isso dará um efeito de digitação sedosa e suave ... */
  ( that.state.forward ) ? that.setState( {interval: 1} ) : false;
  const speed = 1;
  const char = text.slice(index, index + speed);
  index += speed;
  if ( index > text.length ) {
    return;// Se a palavra terminar, retorne
  }
    await writeChars( that, nodeName, char );
    await writeTo(that, nodeName, index, text);
};

export default class Home extends React.Component{
  constructor( props ){ 
    super( props );
    this.state = {
      aboutText: '',
      DOMaboutText: '',
      experienceText: '',
      DOMexperienceText: '',
      educationText: '',
      DOMeducationText: '',
      skillsText: '',
      DOMskillsText: '',
      forward: false,
      interval: 15
    }
  }
  
  componentDidMount() {
    ( async ( that ) =>
    {
      window.scrollTo( 0, 0 );
      await writeTo( that, 'about', 0, style );
      await writeTo( that, 'experience', 0, experience );
      await writeTo( that, 'education', 0, education );
      await writeTo( that, 'skills', 0, skills );
      await writeTo( that, 'about', 0, style2 );

      refAbout.current.scrollTop = 0;
      refExperience.current.scrollTop = 0;
      refEducation.current.scrollTop = 0;
      refSkills.current.scrollTop = 0;
      window.scrollTo( 0, 0 );
    })(this);
  }

  forwardClick = () => this.setState( {forward : true} );

  render()
  {    
    return (
      <Layout>
        <SEO
          description="Full Stack developer"
          keywords="React, Node, Gatsby, Front-end, Full Stack, developer, API"
        />
        <Helmet>
          <script
            async
            src="https://cdn1.stackshare.io/javascripts/client-code.js"
            charset="utf-8"
          />
        </Helmet>
        {!this.state.forward ? (
          <a onClick={this.forwardClick} className="skipButton button is-primary is-outlined is-hovered">
          <span className="icon has-text-success is-large fa-2x">
              <FontAwesomeIcon icon={faForward} />
          </span>
        </a>
        ) : null}
        <figure className="photo image is-128x128">
          <StaticQuery
            query={graphql`
            query {
              file(relativePath: { eq: "profile4.jpg" }) {
                childImageSharp {
                  fixed(width: 128, height: 128) {
                    ...GatsbyImageSharpFixed
                  }
                }
              }
            }
          `}
            render={data => (
              <Img
                fixed={data.file.childImageSharp.fixed}
                imgStyle={{ borderRadius: '100%' }}
                alt="Murillo Henrique"
              />
            )}
          />
        </figure>
        <h1 className="title has-text-centered has-text-light">Murillo Henrique</h1>
        <h2 className="subtitle has-text-centered has-text-warning">Full Stack Developer</h2>
        <div className="has-text-centered">
          <a href="https://github.com/mhsscel" aria-label="github">
            <span className="icon is-large fa-2x">
              <FontAwesomeIcon icon={faGithub} />
            </span>
          </a>
          <a href="https://www.instagram.com/mhsscel" aria-label="instagram">
            <span className="icon is-large fa-2x">
              <FontAwesomeIcon icon={faInstagram} />
            </span>
          </a>
          <a href="https://www.facebook.com/murillossoares" aria-label="facebook">
            <span className="icon is-large fa-2x">
              <FontAwesomeIcon icon={faFacebook} />
            </span>
          </a>
          <a href="https://www.linkedin.com/in/murillossoares" aria-label="linkedin">
            <span className="icon is-large fa-2x">
              <FontAwesomeIcon icon={faLinkedin} />
            </span>
          </a>
          <a href="mailto:murillossoares@gmail.com" aria-label="email">
            <span className="icon is-large fa-2x">
              <FontAwesomeIcon icon={faAt} />
            </span>
          </a>
        </div>

        <section id="about" className="section content is-size-4-desktop is-size-5-touch">
          <div className="about"
          ref={refAbout}>
            <div dangerouslySetInnerHTML={{ __html: this.state.aboutText }}/>
            <style dangerouslySetInnerHTML={{ __html: this.state.DOMaboutText }} />
          </div>
        </section>

        {`
        `}

        <section id="experience" className="section content is-size-4-desktop is-size-6-touch">
          <div className="experience"
          dangerouslySetInnerHTML={{ __html: this.state.DOMexperienceText }}
          ref={refExperience} />
        </section>

        {`
        `}

        <section id="education" className="section content is-size-4-desktop is-size-5-touch">
          <div className="education"
          ref={refEducation}>
            <div dangerouslySetInnerHTML={{ __html: this.state.educationText }}/>
            <style dangerouslySetInnerHTML={{ __html: this.state.DOMeducationText }} />
          </div>
        </section>

        {`
        
        `}

        <section id="skills" className="section content is-size-4-desktop is-size-5-touch">
          <div className="skills"
          dangerouslySetInnerHTML={{ __html: this.state.DOMskillsText }}
          ref={refSkills} />
        </section>
      </Layout>
    );
  }
}
